<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="lg">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('assign_to_group') }} </h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div class="row">
                <div class="col-4">
                    <select2 style="width: 100%" class="" v-model="assignToGroup" :options="groups"
                             :settings="{ width: '100%' }"></select2>
                </div>
            </div>

        </template>
        <template v-slot:modal-footer="{}">
            <div class="row m-b">
                <div class="col-md-12 text-right">
                    <div class="modal-footer">
                        <button type="button" @click="visible = false" class="btn btn-white">{{ __('cancel') }}</button>
                        <button v-if="assignToGroup != 0" type="button" @click="handleAssignToGroup()"
                                class="btn btn-primary">{{ __('OK') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "ModalAssignToItemGroup",
    data: function () {
        return {
            visible: false,
            assignToGroup: 0,
        }
    },
    props: {
        itemsAndGroups: {
            type: Array,
            default: [],
        }
    },
    methods: {
        handleAssignToGroup: function () {
            let itemsToAssign = [];
            this.itemsAndGroups.forEach(group => {
                for (let i = group.standard_items.length - 1; i >= 0; i--) {
                    const standardItem = group.standard_items[i];
                    if (standardItem.checked) {
                        standardItem.checked = false
                        itemsToAssign.push(standardItem);
                        group.standard_items.splice(i, 1);
                    }
                }
            });
            let targetIndex = this.itemsAndGroups.findIndex(item => {
                return item.name == this.assignToGroup;
            })
            for(let i = 0; i <= itemsToAssign.length - 1; i++){
                this.itemsAndGroups[targetIndex].standard_items.push(itemsToAssign[i])
            }
            this.visible = false;
            return this.itemsAndGroups
        }
    },
    computed: {
        groupsWithoutUnallocated: function () {
            return this.itemsAndGroups.filter(group => group.name != 'unallocated')
        },
        groups() {
            let options = [];
            options.push({text: '---', 'id': 0})
            for (var i = 0; i <= this.groupsWithoutUnallocated.length - 1; i++) {
                options.push({text: this.groupsWithoutUnallocated[i].name, 'id': this.groupsWithoutUnallocated[i].name})
            }

            return options
        },
    },
}
</script>

<style scoped>

</style>
